<template>
    <div class="login-wrap" :style="bgStyle"  v-loading="loading2" element-loading-text="正在加载" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 1)" >
        <div class="ms-login"  v-loading="loading" element-loading-text="正在换绑手机号..." element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"> 
             
            <div class="right" > 
                <div class="ms-title">换绑手机号</div>
                <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                    <el-form-item prop="username" class='borderBottom'>
                    
                        <input type="text" v-model.trim="param.username" placeholder="原手机号" /> 
                        <i class="el-icon-user"></i>
                    </el-form-item>
                    <el-form-item prop="password" class="password borderBottom" > 
                        <input type="password"  v-model.trim="param.loginPass" placeholder="原密码"   />
                        <i class="el-icon-lx-lock"></i>
                    </el-form-item>   
                    <el-form-item prop="phone" class='borderBottom'>
                    
                        <input type="text" v-model.trim="param.phone" placeholder="新手机号" /> 
                        <i class="el-icon-mobile-phone"></i>
                    </el-form-item>
                    <el-form-item prop="code" class="borderBottom" > 
                        <input type="text" class='code' oninput ="value=value.replace(/[^\d]/g,'')"  v-model.trim="param.code" placeholder="验证码"  @keyup.enter.native="submitForm" />
                        <el-button v-loading="loading3"
    element-loading-text="正在发送验证码" 
    element-loading-background="rgba(0, 0, 0, 0.8)" class='verification' style='height:35px;border:none; margin-top:5px;font-size:15px;float:right;margin-right:-0px;border-radius:5px;' :disabled="sendSms.disabled"  type="primary" :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                        <i class="el-icon-circle-check"></i>
                    </el-form-item>  
                    
                      
                    <div class="login-btn"> 
                        <button  @click.prevent="submitForm">确认修改</button>
                    </div>   
                    <a style="float:right;margin:5px;color:#0ac1ea;margin:8px;cursor:pointer;"  @click="resetPass">去登陆?</a>
                    <a style="float:right;margin:15px;color:#0ac1ea;margin:8px;cursor:pointer;"  @click="forByInfo">收不到验证码?</a>
                </el-form>
            </div>
            
        </div>
        <!--<div :hidden="loadLayer" style="background-color:#000;width:100%;height:100%;opacity:0.5;">
            <i class="el-icon-loading" style="color:#fff;font-size:80px;position:absolute;float:left;left: 50%; top: 50%;  margin: -110px 0 0 -40px;"></i>
        </div> -->
    </div>
    
</template>

<script>
import { fetchStationInfo,rePhone } from '../../api/login'; 
import {sendSecondCode,createSmsCode} from '../../api/common';
export default {
    data: function() {
        return {
            code:'',
            //loadLayer:true,
            param: {
                id:'',
                username: '',
                password: '',
                code:'',
                stationName:"",
                stationId:"",
                stationLogo:"",
                stationDescriptions:"",
                stationUrl:window.location.host.replace(window.location.port,"").replace(":","")
            }, 
            coverImgUrl:'',  
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             }, 
            loading:false,
            loading3:false,
            loading2:true,
            stationName:"",
            indexUrl:'',
            rules: {
                username: [{ required: true, message: '原手机号', trigger: 'blur' }],
                loginPas: [{ required: true, message: '原密码', trigger: 'blur' }],
                phone: [{ required: true, message: '新手机号', trigger: 'blur' }],
                code: [{ required: true, message: '验证码', trigger: 'blur' }],
            },
        };
        
    },
    computed:{
        bgStyle(){
            return {
                backgroundImage: 'url(' + this.coverImgUrl + ')'
            }
        }
    },   
    created(){ 
        this.getStationInfo(); 
    },
    mounted() {  
    }, 
    
    methods: { 
        sendCode(){   
            //发送短信按钮倒计时提示  
            if(!this.param.username){
                this.$message.error("请输入原手机号"); 
                return;
            }
            if(this.param.username.length!=11){
                this.$message.error("原手机号长度不正确"); 
                return;
            }
            if(!this.param.loginPass){
                this.$message.error("请输入账号密码"); 
                return;
            }
            if(!this.param.phone){
                this.$message.error("请输入新手机号"); 
                return;
            }
            if(this.param.phone.length!=11){
                this.$message.error("新手机号长度不正确"); 
                return;
            }
            var that = this;
            var times = 119;
            this.sendSms.disabled = true; 
            this.sendSms.color ="color:#333;background:#eee";
            this.sendSms.sendFag = "1";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff;background:#3a67e2";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = localStorage.getItem('ms_mid');
            this.sendSms.stationId = localStorage.getItem('ms_stationId'); 
            this.sendSms.loginName = localStorage.getItem('ms_loginName'); 
            this.sendSms.username = this.param.username;   
            this.sendSms.phone = this.param.phone;   
            this.sendSms.loginPass = this.param.loginPass;   
            this.sendSms.code = "-1";
            this.loading3 = true;
            createSmsCode(this.sendSms).then(res => {
                if(res.code=='200'){   
                    this.sendSms.code = "1";
                    this.loading3 = true;
                    setTimeout(() => {
                        //需要定时执行的代码
                        this.loading3 = false;
                        this.$message.success('发送成功');
                    }, 4000)
                }else{   
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff;background:#3a67e2";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                    this.loading3 = false;
                } 
            }); 
            
        },
        createCode(){ 
            createImgCode(this.param).then(res => { 
                if(res.code==200){    
                    this.checkCode = res.data;  
                } 
            }).catch(err =>{ 
                this.$message.error('获取服务器数据失败，请刷新页面');
            }); 
        },
       
        //查询网站站点信息
        getStationInfo(){  
            fetchStationInfo(this.param).then(res => { 
                if(res.code==200){    
                    this.param.stationId = res.data.st;
                    this.param.stationName = res.data.stationName; 
                    this.param.stationLogo = res.data.stationLogo; 
                    this.indexUrl = res.data.indexUrl;
                    this.param.stationDescriptions = res.data.stationDescriptions;  
                    localStorage.setItem('ms_stationId', res.data.st);
                    localStorage.setItem('ms_fid', res.data.id);
                    localStorage.setItem('ms_stationName', res.data.stationName);
                    localStorage.setItem('ms_stationLogo', res.data.stationLogo);
                    localStorage.setItem('ms_android', res.data.androidUrl);
                    localStorage.setItem('ms_apple', res.data.appleUrl);
                    localStorage.setItem('ms_stationUrl', res.data.stationUrl);
                    localStorage.setItem('ms_indexUrl', res.data.indexUrl);
                    localStorage.setItem('ms_customerUrl', res.data.customerUrl);
                    localStorage.setItem('ms_bgPhone', res.data.bgPhone);
                    localStorage.setItem('ms_bgPc', res.data.bgPc);
                    document.title = res.data.stationName;
					document.getElementsByTagName("title")[0].innerText = res.data.stationName;
                    var favicon = document.querySelector('link[rel="icon"]');
                    favicon.href = res.data.stationLogo;
                    let centerWidth = document.documentElement.scrollWidth; 
                    if(centerWidth<1000){
                        this.coverImgUrl = res.data.bgPhone;
                    }else{
                        this.coverImgUrl = res.data.bgPc;
                    }
                    this.loading2 = false;
                    
                } 
            }).catch(err =>{ 
                this.$message.error('获取服务器数据失败，请刷新页面');
            });
            this.loading2 = false;
        },
        
        //忘记密码
        resetPass(){
             this.$router.push('/login');
        },
        forByInfo(){
             this.$router.push('/forByInfo');
        },
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {  
                    if(!this.param.code=='-1'){
                        this.$message.error('请发送验证码');
                        return;
                    } 
                    if(!this.param.username){
                        this.$message.error("请输入原手机号"); 
                        return;
                    }
                    if(this.param.username.length!=11){
                        this.$message.error("原手机号长度不正确"); 
                        return;
                    }
                    if(!this.param.loginPass){
                        this.$message.error("请输入账号密码"); 
                        return;
                    }
                    if(!this.param.phone){
                        this.$message.error("请输入新手机号"); 
                        return;
                    }
                    if(this.param.phone.length!=11){
                        this.$message.error("新手机号长度不正确"); 
                        return;
                    }
                    if(!this.param.code ){
                        this.$message.error('请输入验证码');
                        return;
                    } 
                    this.loading = true;
                    rePhone(this.param).then(res => { 
                         if(res.code=='200'){      
                            this.$message.success('更换手机号成功');
                            this.$router.push('/login');

                         }else{
                             this.loading = false;
                             this.$message.error(res.message);
                         }
                    });
                    
                } else {
                    this.$message.error('请输入个人信息');
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
};
</script>
<style>
    .hkstyle{
        width:400px;
    }  
    .verification{
        height:50px;
        font-size:15px;
    }
    .verification:after{
        background:none;
    } 
</style>
<style scoped>

@media screen and (max-width:999px){
    *,body{
        margin:0;padding:0;
    }
    .login-wrap {  
        width: 86%;
        height: 100%;  
        background:rgb(0 0 0 / 90%);
        background-size:100% 100%;
	    background-attachment:fixed; 
        margin-top:-30px;
        padding:10% 7%; 
    }
    .verification{
       width:90px; 
       position: absolute;right:10px;
    }
    .ms-login{
        background: rgb(255 ,255, 255  );
        height:450px;
        border-radius:8px;
    }
    .right{ 
       text-align: center;
        width: 320px;
        height: 400px; 
        border-radius: 5px;
        width: 100%; 
    }
    .logo{
        width:100%;
        height:150px; 
        margin-top:10px;
        opacity:0.9; 
        border-radius:10px;
    }
    .zhichi{
        font-size:18px;text-align:left;color:#1d36e7;margin-top:40px;
    }
    .parent{
        width:33%;float:left;font-size:13px;text-align:center;
    }
    .hezuo{
        font-size:18px;text-align:left;color:#1d36e7;margin-top:10px;
    }
    .parent img{
        margin-top:20px;
        width:70px;height:70px; 
        border-radius:50%;
    }
    .ms-title {
        margin-top:30%;
        width: 100%;
        line-height: 70px;
        text-align: center;
        font-size: 22px;
        color: #000;
        height:70px;
        padding-top:10px;
        
    
    }
    i{  
        left:0;
        float:left;
        font-size:22px;
        width:15%;
        text-align:center;
        height:44px;
        line-height:44px; 
        border-top-left-radius:5px;
        border-bottom-left-radius:5px;
        z-index:10;  
        color: #333;
    }
    input{
        z-index:1;
        margin-left:0;
        border:none; 
        font-size:14px;
        border-top-right-radius:5px;
        border-bottom-right-radius:5px;
        height:30px;padding:5px 2% 5px 5%; 
        width:70%;  
        color: #333;
        background:none;
    }
    .borderBottom{
        border-bottom:1px solid #999;
    }
    input.is_active,input:hover{
        border:none; 
        
    } 
    input:focus{
        border:none; 
        outline: none;
    }
    .username,.password{
        margin-left:0;
        margin-top:10px;
    }
    button{
        background-color: #3a67e2;
        color:#eee;
        font-size:15px;
        float:left;
        margin-top:10px;
        border-radius:8px;
        border:none;
        width: 100%;
        height: 40px; 
    }
    .ms-content {
        padding: 10px 10%; 
        
    }
    .login-btn {
        text-align: center;
        opacity:1;
    } 
    .login-tips {
        font-size: 15px;
        line-height: 30px;
        color: #fff;
    }
    input::-webkit-input-placeholder { /* WebKit browsers */ 
color:#999; 
} 

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
color:#999;  
} 

input::-moz-placeholder { /* Mozilla Firefox 19+ */ 
color:#999; 
} 

input:-ms-input-placeholder { /* Internet Explorer 10+ */ 
color:#999; 
}  
input::-webkit-input-placeholder { /* WebKit browsers */ 
color:#999; 
} 

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
color:#999;  
} 

input::-moz-placeholder { /* Mozilla Firefox 19+ */ 
color:#999; 
} 

input:-ms-input-placeholder { /* Internet Explorer 10+ */ 
color:#999; 
}  
 
}

@media screen and (min-width:1000px){/*宽度小于等于320,同理*/
 
    .login-wrap { 
        width: 100%;
        height: 100%;  
        background:rgb(0 0 0 / 90%);
        background-size:100% 100%;
	    background-attachment:fixed;
        position:relative;
    }
    .verification{
       width:120px; 
       position: absolute;right:15px;
    }
   
   
    .right{
        position:fixed; 
        margin-top:10%;
        right: 2%; 
        float:right;
        width:350px;
        height:450px;
        margin-right:15%;  
        border-radius:5px;
    }
    .logo{
        width:100%;
        height:150px; 
        margin-top:10px;
        opacity:0.9; 
        border-radius:10px;
    }
    .zhichi{
        font-size:18px;text-align:left;color:#1d36e7;margin-top:40px;
    }
    .parent{
        width:33%;float:left;font-size:13px;text-align:center;
    }
    .hezuo{
        font-size:18px;text-align:left;color:#1d36e7;margin-top:10px;
    }
    .parent img{
        margin-top:20px;
        width:70px;height:70px; 
        border-radius:50%;
    }
    .ms-title {
        margin-top:30px;
        width: 100%;
        line-height: 70px;
        text-align: center;
        font-size: 25px;
        color: #333;
        height:70px; 
        color:#fff;
    }
    i{  
        left:0;
        float:left;
        font-size:22px;
        width:15%;
        text-align:center;
        height:44px;
        line-height:44px; 
        border-top-left-radius:5px;
        border-bottom-left-radius:5px;
        z-index:10;  
        color:#fff;
    }
    input{
        z-index:1;
        margin-left:0;
        border:none; 
        font-size:17px;
        border-top-right-radius:5px;
        border-bottom-right-radius:5px;
        height:30px;padding:5px 2% 5px 5%;   
         background:none;
         color:#fff;
    }
    .borderBottom{
        border-bottom:1px solid #aaa;
    }
    input.is_active,input:hover{
        border:none; 
        
    } 
    input:focus{
        border:none; 
        outline: none;
    }
    .username,.password{
        margin-left:0;
        margin-top:20px;
    }
    button{
        background-color: #3a67e2;
        color:#eee;
        font-size:18px;
        float:left;
        margin-top:15px;
        border-radius:8px;
        border:none;
        width: 90%;
        margin:0 5%;
        margin-top:10px;
        height: 45px; 
    }
    .ms-content {
        padding: 10px 30px;
        
    }
    .login-btn {
        text-align: center;
        opacity:1;
    } 
    .login-tips {
        font-size: 15px;
        line-height: 30px;
        color: #fff;
    }
    input::-webkit-input-placeholder { /* WebKit browsers */ 
color:#ddd; 
} 

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
color:#ddd;  
} 

input::-moz-placeholder { /* Mozilla Firefox 19+ */ 
color:#ddd; 
} 

input:-ms-input-placeholder { /* Internet Explorer 10+ */ 
color:#ddd; 
}  
input::-webkit-input-placeholder { /* WebKit browsers */ 
color:#ccc; 
} 

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
color:#ccc;  
} 

input::-moz-placeholder { /* Mozilla Firefox 19+ */ 
color:#ccc; 
} 

input:-ms-input-placeholder { /* Internet Explorer 10+ */ 
color:#ccc; 
}  
 
 
}


input:-webkit-autofill, 
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active { 
-webkit-transition-delay: 99999s; 
-webkit-transition: color 99999s ease-out, background-color 99999s ease-out;

}
</style>